import { useStoreValue } from '../../state/hooks/useStore';
import { useLanguageValue } from '../../state/hooks/useLanguage';
import { Feature, isEnabled } from '../utils/featureToggle';

export function useIsEnabled(feature: Feature): boolean {
  const store = useStoreValue();
  const language = useLanguageValue();

  return isEnabled(feature, store, language);
}
